<template>
	<div>
		<sBox title="Grade de Passaporte">
			<div slot="tools">
				<div class="box-excel-export">
					<aBtn
						action="private-save-passaport2"
						@click="$refs.modalExcel.open()"
						text="Importar Excel"
						icon="plus"
						size="sm"
						type="info"
						class="btn-export"
					/>

					<aBtn
						class="btn-import"
						@click="handleConvertTableToXLS()"
						text="Exportar Excel"
						icon="minus"
						size="sm"
						type="info"
					/>
				</div>
			</div>
			<div slot="body">
				<br />
				<sBox title="Filtrar Passaporte">
					<div class="row" slot="body">
						<div class="col-sm-3">
							<span>id</span>
							<input
								v-model="filter.id"
								@input="fxFilter('id', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="ID"
							/>
						</div>
						<div class="col-md-3">
							<span>nome</span>
							<input
								v-model="filter.nome"
								@input="fxFilter('nome', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="NOME"
							/>
						</div>

						<div class="col-sm-3">
							<span>passaport</span>
							<input
								v-model="filter.passaport"
								@input="
									fxFilter('passaport', $event.target.value)
								"
								type="text"
								class="form-control"
								placeholder="PASSAPORT"
							/>
						</div>
					</div>
				</sBox>

				<br />
				<!-- action='private-save-passaport2'	 -->
				<!-- @click='this.handleConvertTableToXLS()' -->
				<div class="box-excel-export">
					<aBtn
						action="private-save-passaport"
						@click="$refs.modal.open()"
						text="Passaporte"
						icon="plus"
						size="sm"
						type="success"
					/>
				</div>

				<br />
				<sTable
					ref="tab"
					actionRead="private-read-passaport"
					actionDelete="private-delete-passaport"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<modal2 ref="modalExcel" id="modal2" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import modal2 from './modal2.vue';
	import pad from 'js/pad';
	var XLSX = require('xlsx');

	export default {
		name: 'AppCadastroPassaporte',
		components: { sTable, sBox, modal, aBtn, modal2 },
		data() {
			return {
				labels: [
					{ data: 'id', label: 'ID' },
					{ data: 'nome', label: 'Nome' },
					{ data: 'passaport', label: 'Passaporte' },
				],
				// functions: [
				// 	{ cod: 'cod', fx: (val)=>{return pad(val, 5)} }
				// ]

				filter: {
					id: '',
					nome: '',
					passaport: '',
				},
			};
		},
		methods: {
			fxFilter(col, val) {
				let f = [];

				if (this.filter.id != '')
					f.push(`id like '%${this.filter.id}%'`);

				if (this.filter.nome != '')
					f.push(`nome like '%${this.filter.nome}%'`);

				if (this.filter.passaport != '')
					f.push(`passaport like '%${this.filter.passaport}%'`);

				f = f.join(' and ');

				// console.log(f)

				console.log(f);

				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},

			handleConvertTableToXLS() {
				const mainTable = document.querySelector('.table');
				console.log(mainTable);

				const jsonExcelData = XLSX.utils.table_to_book(mainTable);

				console.log(jsonExcelData);

				const nameOfFile = 'Dados dos Passaporte.xlsx';

				XLSX.writeFile(jsonExcelData, nameOfFile);
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento de Passaporte', '']);
		},
	};
</script>

<style>
	.box-excel-export {
		width: 100%;
		display: flex;
		justify-content: end;
	}

	.btn-import {
		margin-left: 15px;
	}

	.btn-export {
		filter: saturate(1.5);
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/passaport/index.vue